module.exports = __webpack_public_path__ + "assets/img/robot_test_l1.35d7d137.jpg";